var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance__main-container"},[_c('MaintenanceSvg',{staticClass:"maintenance-svg"}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message"},[_vm._v(" Please bear with us, this feature is coming soon... "),_c('p',{staticClass:"text-right"},[_vm._v(" - Team JDEV ")])])
}]

export { render, staticRenderFns }